import React from 'react';

const SponsorFooter = ({ onHowItWorks }) => {
  const sponsors = [
    { name: "Generate Policy", url: "https://generatepolicy.com/" },
    { name: "Cyber Agent Exchange", url: "https://cyberagent.exchange/" },
    { name: "CISO Marketplace", url: "https://cisomarketplace.services/" },
    { name: "SSAE Physical Security", url: "https://ssaephysicalsecurity.com/" },
    { name: "SOC Assessment", url: "https://socassessment.com/" }
  ];

  return (
    <>
      <style>
        {`
          @media print {
            .sponsor-footer {
              display: block !important;
              page-break-inside: avoid;
              margin-top: 2rem;
              text-align: center;
              border-top: 1px solid #eee;
              padding-top: 1rem;
            }
            .sponsors-list {
              display: flex !important;
              flex-wrap: wrap;
              justify-content: center;
              gap: 1rem;
            }
            .sponsor-link {
              font-size: 9pt;
              color: #555;
            }
            .footer-nav {
              display: none;
            }
          }
        `}
      </style>

      <div className="sponsor-footer mt-8 pt-4 border-t border-slate-200">
        {/* Sponsors */}
        <div className="sponsors-section mb-4">
          <h4 className="text-sm text-gray-500 text-center mb-3">Report Sponsored By</h4>
          <div className="sponsors-list flex flex-wrap justify-center gap-6">
            {sponsors.map((sponsor, index) => (
              <a
                key={index}
                href={sponsor.url}
                target="_blank"
                rel="noopener noreferrer"
                className="sponsor-link text-gray-500 hover:text-blue-600 text-sm transition-colors"
              >
                {sponsor.name}
              </a>
            ))}
          </div>
        </div>

        {/* Footer nav */}
        <div className="footer-nav border-t border-slate-100 pt-3 mt-3 flex flex-wrap items-center justify-center gap-4 text-xs text-slate-400">
          <button
            onClick={onHowItWorks}
            className="hover:text-blue-600 transition-colors"
          >
            How It Works
          </button>
          <span>·</span>
          <a
            href="https://www.hhs.gov/hipaa/for-professionals/security/index.html"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-blue-600 transition-colors"
          >
            HHS OCR HIPAA Resources
          </a>
          <span>·</span>
          <a
            href="https://www.fda.gov/medical-devices/digital-health-center-excellence/cybersecurity"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-blue-600 transition-colors"
          >
            FDA Device Cybersecurity
          </a>
          <span>·</span>
          <span>&copy; {new Date().getFullYear()} DeviceRisk | ComplianceHub.wiki</span>
        </div>
      </div>
    </>
  );
};

export default SponsorFooter;
